import { createSelector } from 'reselect'
import { getPageData, getPageParams } from 'selectors/page'
export const getIsDetailPage = createSelector(getPageParams, (params): boolean => {
  const { titleSlug } = params
  return !!titleSlug
})
export const getShowsIntro = createSelector(getPageData, (pageData): string => {
  const { intro } = pageData
  return intro || ''
})
export const getShowsItems = createSelector(
  getPageData,
  (pageData): Array<any> => {
    const { items } = pageData
    return items || []
  }
)
export const getTitleSlug = createSelector(getPageParams, (pageParams): string => {
  const { titleSlug } = pageParams
  return titleSlug || ''
})
export const getShowData = createSelector(
  [getShowsItems, getTitleSlug],
  (items, titleSlug): Record<string, any> => {
    const showData = items.filter(({ slug }) => slug === titleSlug)

    if (showData.length) {
      // Temporary cleanup for some escaped smartquotes that go into the data.
      // Remove once resolved.
      const { detailCopy } = showData[0]
      const cleanDetailCopy = detailCopy.replace(/\\“/g, '')
      const { listingBlurb } = showData[0]
      const cleanListingBLurb = listingBlurb.replace(/\\“/g, '')
      const cleanShowData = {
        ...showData[0],
        ...{
          detailCopy: cleanDetailCopy,
          listingBlurb: cleanListingBLurb,
        },
      }
      return cleanShowData || {}
    }

    return {}
  }
)
export const getFirstParagraph = createSelector(getShowData, (showData): string => {
  const firstParagaph = showData.detailCopy && showData.detailCopy.split('/n/n')[0]
  return firstParagaph || ''
})